import { Injectable } from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

interface IconDefinition {
  name: string;
  path: string;
}

const icons: IconDefinition[] = [
  {name: 'preview', path: 'assets/icons/live_tv.svg'},
  {name: 'Organizations', path: '/assets/vvcr-icons/Organizations.svg'},
  {name: 'Organization', path: '/assets/vvcr-icons/Organization.svg'},
  {name: 'Account', path: '/assets/vvcr-icons/Account.svg'},
  {name: 'Logout', path: '/assets/vvcr-icons/Logout.svg'},
  {name: 'help', path: 'assets/vvcr-icons/Help.svg'}
];

@Injectable({
  providedIn: 'root'
})
export class IconsLoaderService {

  constructor(
    private readonly iconRegistry: MatIconRegistry,
    private readonly sanitizer: DomSanitizer
  ) {
  }

  public loadIcons(): void {
    for (const icon of icons) {
      const name: string = icon.name;
      const path: string = icon.path;
      const safePath: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(path);
      this.iconRegistry.addSvgIcon(name, safePath);
    }
  }
}
